import AuthService from "../service/authService";
import { jwtDecode } from "jwt-decode";

export default class Account {
    static accountInstance : Account;
    accntId:string;
    accntRole:string;

    constructor(){
        this.accntId= "1234"
        this.accntRole = "tnt_superAdmin"
    }
    static getInstance() {
        if (!Account.accountInstance) {
            Account.accountInstance = new Account();
        }
        return this.accountInstance;
    }
     async fetchAccountId() {
        let a = await AuthService.getInstance().getIdToken();
        const decoded: any = jwtDecode(a);
        const tenantIdValue = decoded["custom:tenantId"];
        const tenantRoleValue = decoded["custom:role"];
        this.accntId=tenantIdValue
        this.accntRole=tenantRoleValue
      }
}


